<template>
  <a-modal
    v-model="visible"
    :footer="null"
    :destroyOnClose="true"
    width="1200px"
    wrapClassName="recommend-modal"
    @cancel="close"
    :key="resume && resume.id"
  >
    <div v-if="resume">
      <a-row type="flex" justify="center">
        <a-col span="15" class="steps">
          <a-steps :current="tab">
            <a-step title="软性点评"></a-step>
            <a-step title="推荐报告" />
            <a-step title="完成" />
          </a-steps>
        </a-col>
      </a-row>
      <a-tabs :activeKey="tab" :animated="false" class="tabs">
        <a-tab-pane tab :key="0">
          <h3>
            <b>候选人信息：</b>
          </h3>
          <div class="info">
            <a-row
              class="row"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <a-col class="col gap">
                <span class="name">{{ resume.name }}</span>
                <span class="match"
                  >(匹配度：{{ resume.matching_perfection }}%)</span
                >
              </a-col>
              <a-col class="col gap">
                <span>
                  <icon-font type="dianhua"></icon-font>
                  {{ resume.mobile }}
                </span>
                <span>
                  <icon-font type="youxiang"></icon-font>
                  {{ resume.email }}
                </span>
              </a-col>
            </a-row>
            <a-row
              class="row"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <a-col class="col">
                <span>{{ resume.gender_id | sexy }}</span>
                <a-divider type="vertical" />
                <span>{{ resume.city_name }}</span>
                <a-divider type="vertical" />
                <span>{{ resume.education_name }}</span>
                <a-divider type="vertical" />
                <span>{{ resume.working_years_name }}工作经验</span>
              </a-col>
            </a-row>
            <a-row
              class="row"
              type="flex"
              justify="space-between"
              align="middle"
            >
              <a-col class="col2">
                <span>
                  {{ resume.first_category_name }}
                  <span
                    :class="[
                      resume.second_category_name == '' ||
                      resume.first_category_name == '' ||
                      (resume.second_category_name == '' &&
                        resume.first_category_name == '')
                        ? 'hide'
                        : 'show'
                    ]"
                    >/</span
                  >
                  {{ resume.second_category_name }}
                  <span
                    :class="[
                      resume.second_category_name == '' ||
                      resume.third_category_name == '' ||
                      (resume.second_category_name == '' &&
                        resume.third_category_name == '')
                        ? 'hide'
                        : 'show'
                    ]"
                    >/</span
                  >
                  {{ resume.third_category_name }}
                </span>
                <a-divider type="vertical" />
                <span>{{ resume.last_company }}</span>
              </a-col>
            </a-row>
            <template v-if="resume.authorized_at">
              <a-divider />
              <a-row
                class="row"
                type="flex"
                justify="space-between"
                align="middle"
              >
                <a-col class="col">
                  <span class="time">
                    <span
                      >{{ resume.user && resume.user.name }} 于
                      {{ resume.authorized_at }} 授权</span
                    >
                  </span>
                </a-col>                
              </a-row>
              
              <a-row v-if="resume.authorized_recommendation && resume.authorized_recommendation.length > 0">
                <div style="height: 10px;"></div>
                <span class="time">
                    <span
                      >猎头推荐语：
                      {{ resume.authorized_recommendation }}</span
                    >
                  </span>
              </a-row>
            </template>
          </div>
          <comment ref="comment"></comment>
        </a-tab-pane>
        <a-tab-pane tab :key="1">
          <report ref="report" :resume="resume" :job-name="job_name"></report>
        </a-tab-pane>
        <a-tab-pane tab :key="2">
          <done :resume="resume" :id="order_no" :job-name="job_name"></done>
        </a-tab-pane>
      </a-tabs>
      <a-row type="flex" justify="end" align="middle" :gutter="20">
        <a-divider></a-divider>
        <a-col>
          <a-button :loading="loading" @click="doCancleBtn" v-if="cancle">{{
            cancle
          }}</a-button>
        </a-col>
        <a-col>
          <a-button type="primary" @click="doSureBtn">{{ sure }}</a-button>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import Comment from "@/components/soft-comment";
import Report from "./report";
import Api from "@/api";
import Done from "./done";

export default {
  name: "Recomend",
  props: {
    callback: {
      type: Function,
      default:null
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      resume: null,
      tab: 0,
      cancle: "取消",
      sure: "下一步",
      tags: [],
      job_id: "",
      job_name: "",
      order_no: "",
      order_id: 0,
      recommend_result_id: ''
    };
  },
  watch: {
    tab(val) {
      switch (val) {
        case 0: {
          this.cancle = "取消";
          this.sure = "下一步";
          break;
        }
        case 1: {
          this.cancle = "上一步";
          this.sure = "推荐";
          break;
        }
        case 2: {
          this.cancle = "查看订单";
          this.sure = "继续推荐";
          break;
        }
        default: {
          this.tab = val < 0 ? 0 : 2;
          break;
        }
      }
    }
  },
  components: { Comment, Report, Done },
  methods: {
    doCancleBtn() {
      if (this.tab == 0) {
        this.close();
        return;
      }
      if (this.tab == 1) {
        this.tab--;
        return;
      }
      if (this.tab == 2) {
        this.close();
        this.$router.push("/hunter-order");
        return;
      }
    },
    doSureBtn() {
      if (this.tab == 0) {
        let tags = this.$refs.comment.getCommentFormData();
        if (tags) {
          this.tab++;
          this.tags = tags;
        }
        return;
      }
      if (this.tab == 1) {
        this.$refs.report
          .submit()
          .then(async value => {
            value.post_reason = JSON.stringify(value.post_reason);
            let params = {
              ...value,
                tags: this.tags,
                job_id: this.job_id,
                resume_id: this.resume.id,
            }
            if(this.recommend_result_id) {
              params.recommend_result_id = this.recommend_result_id;
            }
            this.loading = true;
            let response;
            try {
              response = await Api.position.postResume(params);
              this.order_no = response.order_no;
              this.order_id = response.id;
              this.tab++;
            } catch (e) {}
            this.loading = false;
          })
          .catch(() => {});
        return;
      }
      if (this.tab == 2) {
        this.close();
        this.callback && this.callback;
        return;
      }
    },
    show(resume, orderId, orderName, recommend_result_id='') {
      console.log(resume);
      this.resume = resume;
      this.job_id = orderId;
      this.job_name = orderName;
      this.recommend_result_id = recommend_result_id;
      this.visible = true;
    },
    async close() {
      this.visible = false;
      await this.$nextTick();
      this.tab = 0;
    }
  }
};
</script>
<style lang="scss">
.recommend-modal {
  .info {
    padding: 20px;
    border-radius: 3px;
    border: 1px solid rgba(228, 232, 235, 1);
  }
  .ant-modal-body {
    .steps {
      padding-top: 20px;
    }
    .tabs {
      .ant-tabs-bar {
        padding-bottom: 30px;
        border: none;
        .ant-tabs-nav-container {
          display: none;
        }
      }
    }
  }
}
</style>
